import angular from 'angular';
import _ from "lodash";

class inviteSubentityDetailsCtrl {

    /* @ngInject */
    constructor($stateParams, KissSellerSvc, logger, PrincipalSvc, CooperativeSvc,$state,$window) {
        this.subEntityId = $stateParams.subEntityId;
        this.KissSellerSvc = KissSellerSvc;
        this.PrincipalSvc = PrincipalSvc;
        this.CooperativeSvc = CooperativeSvc;
        this.logger = logger;
        this.$state = $state;
        this.$window = $window;
    }

    $onInit() {
        this.subEntity = _.cloneDeep(this.subEntity);
        this.cooperative = null;
        this.isPartOfCommunityUsingStockSoftware(this.subEntity.legalEntity.id)
        if (this.subEntity.cooperativeId) {
            this.CooperativeSvc.getCooperative(new String(this.subEntity.cooperativeId)).then(
                (data)=>{
                    this.cooperative = data;
                }
            );
        }
        this.subEntityType = this.getSubEntityType();
        this.setSubEntityCountry(this.subEntity.countryCode);
    }

    setSubEntityCountry(country) {
        if (country && this.countries) {
            this.subEntity.country = _.find(this.countries, { code: country });
        }
    }

    isPartOfCommunityUsingStockSoftware(legalEntityId) {
        return this.PrincipalSvc.hasCommunityHandlingStockSoftware(legalEntityId).then(
            (response) => {
                this.canShowExchange = response;
            }
        );
    }

    back(){
        if(this.invitedEntityId){
            this.$state.go('app.invitedentity.edit',{ id : this.invitedEntityId });
        }else{
            this.$window.history.back();
        }
    }

    getSubEntityType(){
        switch (this.subEntity.type) {
            case 'PRIMARY':
                return "Etablissement Principal";
            case 'SECONDARY':
                return "Etablissement Secondaire";
            case 'COMPLEMENTARY':
                return "Etablissement Complémentaire";
            default:
                return null;
        }
    }
}

angular.module('app.invitedentity').component('invitedDetailsSubEntities', {
    templateUrl: require('./invited-details-subentities.html'),
    controller: inviteSubentityDetailsCtrl,
    bindings: {
        subEntity: '<',
        invitedEntityId: '<',
        countries: '<'
    },
})
